import { defineStore } from "pinia";
import { RouteLocationRaw } from "vue-router";
import { PriorityQueue } from "@/utils";

export enum AlertPriority {
    Info = 0,
    Warning = 1,
    Error = 2,
    AxiosError = 3,
}

export interface Alert {
    contents: string;
    priority: AlertPriority;
    backgroundColor: string;
    buttonColor: string;
    timeout: number;
    /** Optional navigation action rendered next to Close, e.g. the created ticket's key. */
    link: { text: string; to: RouteLocationRaw } | null;
}

export type AlertModel = Partial<Alert>;

export type AlertsState = {
    alerts: PriorityQueue<Alert>;
};

export const useAlertsStore = defineStore("alerts", {
    state: (): AlertsState => ({
        alerts: new PriorityQueue(),
    }),
    actions: {
        enqueueAlert(alertModel: AlertModel) {
            const alert = {
                contents: alertModel.contents ?? "",
                priority: alertModel.priority ?? AlertPriority.Info,
                backgroundColor: alertModel.backgroundColor ?? "surface",
                buttonColor: alertModel.buttonColor ?? "primary",
                timeout: alertModel.timeout ?? 5000,
                link: alertModel.link ?? null,
            };
            this.alerts.enqueue(alert, alert.priority);
        },

        dequeueAlert() {
            this.alerts.dequeue();
        },
    },
    getters: {
        getCurrentAlert: (state) => {
            if (state.alerts.isEmpty()) {
                return null;
            } else {
                return state.alerts.values[0]!.value;
            }
        },
    },
});
